import { BabyFaceIcon } from './BabyFaceIcon';

/**
 * author: Google
 * id 78A84DE8-3ED5-4F81-991B-8EAE452908D3
 * name baby-face
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/baby-face.svg
 * tags
 * - People / Family 
 */
export const EmojiBabyIcon = BabyFaceIcon;
export default EmojiBabyIcon